<template>
    <ul>
        <component
            :is="resolveNavItemComponent(item)"
            v-for="item in items"
            :key="item.header || item.title"
            :item="item"
        />
    </ul>
</template>

<script>
import VerticalNavMenuLink from './vertical-nav-menu-link.vue';
import VerticalNavMenuGroup from './vertical-nav-menu-group.vue';

export default {
    components: { VerticalNavMenuLink, VerticalNavMenuGroup },
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    provide() {
        return {
            openGroups: [],
        };
    },
    methods: {
        resolveNavItemComponent(item) {
            if (item.children) return 'vertical-nav-menu-group';
            return 'vertical-nav-menu-link';
        },
    },
};
</script>
